import "core-js/modules/es6.regexp.replace";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _delay from "lodash/delay";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapMutations } from 'vuex';
import { SLOW_TIMER } from '~/const/timers';
import CategoryFiltersBar from '~/components/templates/Category/CategoryFiltersBar.vue';
import CategoryFiltersList from '~/components/templates/Category/CategoryFiltersList.vue';
import CategorySortsLoading from '~/components/organisms/Category/Loading/CategorySortsLoading.vue';
import CategoryProductListLoading from '~/components/organisms/Category/Loading/CategoryProductListLoading.vue';
import CategoryProductCount from '~/components/molecules/Category/CategoryProductCount.vue';
import CategorySorts from '~/components/organisms/Category/CategorySorts.vue';
import CategoryProductList from '~/components/organisms/Category/CategoryProductList.vue';
import CategoryStickyButtons from '~/components/organisms/Category/CategoryStickyButtons.vue';
import CategoryLayer from '~/components/organisms/Category/CategoryLayer.vue';
import CommercialBanner from '~/components/atoms/Global/CommercialBanner.vue';
import MdmInfiniteScroll from '~/components/atoms/Global/MdmInfiniteScroll.vue';
import MdmPagination from '~/components/atoms/Global/MdmPagination.vue';
const PRODUCTS_PER_PAGE = 40;
export default {
  name: 'CategoryTemplate',
  components: {
    CategoryFiltersBar,
    CategoryFiltersList,
    CategorySortsLoading,
    CategoryProductCount,
    CategoryProductListLoading,
    CategorySorts,
    CategoryProductList,
    CategoryStickyButtons,
    CategoryLayer,
    CommercialBanner,
    MdmInfiniteScroll,
    MdmPagination
  },
  props: {
    serverFetch: {
      type: Boolean,
      default: false
    },
    nextPage: {
      type: Number,
      required: true
    },
    loadingNextPage: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      required: true
    },
    loadingProducts: {
      type: Boolean,
      default: false
    },
    previousPage: {
      type: Number,
      required: true
    },
    loadingPreviousPage: {
      type: Boolean,
      default: false
    },
    currentPath: {
      type: String,
      required: true
    },
    description: {
      type: Object,
      required: true
    },
    breadcrumb: {
      type: Array,
      required: true
    },
    productsCount: {
      type: Number,
      required: true
    },
    filters: {
      type: Array,

      default() {
        return null;
      }

    },
    selectedFilters: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      selectedLayer: null
    };
  },

  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    seeResultsLabel() {
      return "".concat(this.$t('see-results'), " (").concat(this.productsCount, ")");
    },

    paginationTracking() {
      return {
        data: {
          event_category: 'Categorie',
          event_action: 'Clic_plus de produits',
          event_label: "".concat(window.tc_vars.page_cat1, "_").concat(window.tc_vars.page_cat3)
        }
      };
    },

    infiniteFrom() {
      return this.nextPage * PRODUCTS_PER_PAGE;
    },

    progressMsg() {
      const x = this.infiniteFrom < this.productsCount ? this.infiniteFrom : this.productsCount;
      return this.$t('message', {
        x,
        y: this.productsCount
      });
    }

  }),

  mounted() {
    this.listenMatchMedia('DESKTOP', () => {
      _delay(() => {
        this.open = false;
        this.enableWindowScroll();
      }, SLOW_TIMER);
    });
    this.bindScrollListener();
  },

  beforeDestroy() {
    this.enableWindowScroll();
  },

  destroyed() {
    this.unbindScrollListener();
  },

  methods: _objectSpread({}, mapMutations({
    resetFilters: 'pageActions/RESET_FILTERS'
  }), {
    reset() {
      this.$emit('on-reset-filters');
      this.resetFilters();
    },

    bindScrollListener() {
      window.addEventListener('scroll', this.handleScrollOnce, {
        once: true,
        passive: true
      });
    },

    unbindScrollListener() {
      window.removeEventListener('scroll', this.handleScrollOnce);
    },

    handleScrollOnce() {
      this.unbindScrollListener();
    },

    handleOpenLayer(layer) {
      this.disableWindowScroll();
      this.selectedLayer = layer;
    },

    handleCloseLayer() {
      this.enableWindowScroll();
      this.selectedLayer = null;
    },

    formatUrl(url) {
      return url.replace(':market', this.locale.market).replace(':language', this.locale.language);
    }

  })
};